module.exports = __webpack_public_path__ + "img/botas.2662d94b.jpg";